import { render, staticRenderFns } from "./micro-router.vue?vue&type=template&id=fedbed18"
import script from "./micro-router.vue?vue&type=script&lang=js"
export * from "./micro-router.vue?vue&type=script&lang=js"
import style0 from "./micro-router.vue?vue&type=style&index=0&id=fedbed18&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports